import React from 'react';
import { BRAND } from '../../constants/main';
import { DealerCommentStyledAC } from './AC/DealerCommentStyled.AC';
import { DealerCommentStyledOV } from './OV/DealerCommentStyled.OV';
import { DealerCommentStyledAP } from './AP/DealerCommentStyled.AP';
import { DealerCommentStyledDS } from './DS/DealerCommentStyled.DS';
import { DealerCommentStyled } from './DealerCommentStyled';
import { SC } from '../../styles/theme';

export interface DealerCommentProps extends SC {
    generatedIndex?: number;
    withoutBorderTop?: boolean;
}

const DealerComment = (props: DealerCommentProps) => {
    if (BRAND === 'AC') return <DealerCommentStyledAC {...props} />;
    if (BRAND === 'OV') return <DealerCommentStyledOV {...props} />;
    if (BRAND === 'AP') return <DealerCommentStyledAP {...props} />;
    if (BRAND === 'DS') return <DealerCommentStyledDS {...props} />;
    return <DealerCommentStyled {...props} />;
};

export default DealerComment;
